import { Link } from 'react-router';
import { Phone, Mail, Menu, X } from 'lucide-react';
import { useState } from 'react';
import { Button } from './ui/button';
import { useSettings } from '../contexts/SettingsContext';

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { settings } = useSettings();

  const navigateToContact = () => {
    // Navigate to home page first, then scroll to contact section
    window.location.href = '/#contact';
  };

  return (
    <header className="bg-white shadow-sm">
      {/* Top Bar */}
      <div className="bg-[#D4AF37] text-white py-2">
        <div className="container mx-auto px-4 flex justify-between items-center text-sm">
          <div className="flex gap-6">
            <a href={`tel:${settings.phone}`} className="flex items-center gap-2 hover:text-[#FFE5A0] transition-colors">
              <Phone className="w-4 h-4" />
              <span>اتصل: {settings.phone}</span>
            </a>
            <a href={`mailto:${settings.email}`} className="flex items-center gap-2 hover:text-[#FFE5A0] transition-colors">
              <Mail className="w-4 h-4" />
              <span>البريد: {settings.email}</span>
            </a>
          </div>
          <div className="flex gap-4">
            <button className="hover:text-[#FFE5A0] transition-colors">تسجيل الدخول</button>
            <span>/</span>
            <button className="hover:text-[#FFE5A0] transition-colors">التسجيل</button>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            {settings.logo ? (
              <img src={settings.logo} alt={settings.siteNameArabic} className="h-10 object-contain" />
            ) : (
              <div className="text-[#8B7109] text-2xl font-bold">
                <span className="text-[#D4AF37]">دار</span> العقار
              </div>
            )}
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-gray-700 hover:text-[#D4AF37] transition-colors font-medium">
              الرئيسية
            </Link>
            <Link to="/properties" className="text-gray-700 hover:text-[#D4AF37] transition-colors font-medium">
              العقارات
            </Link>
            <Link to="/properties?type=sale" className="text-gray-700 hover:text-[#D4AF37] transition-colors font-medium">
              عقارات للبيع
            </Link>
            <Link to="/properties?type=rent" className="text-gray-700 hover:text-[#D4AF37] transition-colors font-medium">
              عقارات للإيجار
            </Link>
            <Link to="/about" className="text-gray-700 hover:text-[#D4AF37] transition-colors font-medium">
              من نحن
            </Link>
            <button onClick={navigateToContact} className="text-gray-700 hover:text-[#D4AF37] transition-colors font-medium bg-transparent border-none cursor-pointer">
              اتصل بنا
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button onClick={navigateToContact} className="bg-[#D4AF37] hover:bg-[#B8960C] text-white px-6">
                احجز الآن
              </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col gap-4 border-t pt-4">
            <Link to="/" className="text-gray-700 hover:text-[#D4AF37] transition-colors font-medium">
              الرئيسية
            </Link>
            <Link to="/properties" className="text-gray-700 hover:text-[#D4AF37] transition-colors font-medium">
              العقارات
            </Link>
            <Link to="/properties?type=sale" className="text-gray-700 hover:text-[#D4AF37] transition-colors font-medium">
              عقارات للبيع
            </Link>
            <Link to="/properties?type=rent" className="text-gray-700 hover:text-[#D4AF37] transition-colors font-medium">
              عقارات للإيجار
            </Link>
            <Link to="/about" className="text-gray-700 hover:text-[#D4AF37] transition-colors font-medium">
              من نحن
            </Link>
            <button onClick={navigateToContact} className="text-gray-700 hover:text-[#D4AF37] transition-colors font-medium bg-transparent border-none cursor-pointer">
              اتصل بنا
            </button>
            <Button onClick={navigateToContact} className="bg-[#D4AF37] hover:bg-[#B8960C] text-white w-full">
                احجز الآن
              </Button>
          </nav>
        )}
      </div>
    </header>
  );
}